import React from 'react';
import {commonJump} from 'utils/utils';
import {inject, observer} from 'mobx-react';
// import Slide from '../Slide';

import './index.scss';
import {IMG_PATH} from '../../constant';

@inject(({store}) => ({
    rqgl: store.renderData.rqgl
}))
@observer
class Guide extends React.Component {
    state = {
        show: false
    }

    changeBlock() {
        this.setState({
            show: !this.state.show
        });
    }


    render() {
        const {rqgl: {data = []}} = this.props;
        let dataList = [];
        if (!data.length) {
            return null;
        } else if (data.length > 4) {
            dataList = !this.state.show ? data.slice(0, 4) : data;
        } else {
            dataList = data;
        }
        return <div className="module m-nav m-guide" id="rqgl">
            <img className="img-bg" src={`${IMG_PATH}/rqgl.png`} />
            <div className="mg-content">
                {
                    dataList.map((v, k) => {
                        const {img = {}, jumpInfo = {}, title, desc} = v;
                        return <div className="mg-item" key={k} data-sk-eid="list_gonglue" data-sk-edata={JSON.stringify({url: jumpInfo})} onClick={() => {
                            commonJump(jumpInfo);
                        }}>
                            <img className="img" src={img.touch}></img>
                            <div className="content">
                                <img className="img-bg" src={`${IMG_PATH}/newg_bg.png`} />
                                <div className="cont">
                                    <div className="title">{title}</div>
                                    <div className="desc">{desc}</div>
                                </div>
                            </div>
                        </div>;
                    })
                }
            </div>
            {
                data.length > 4 && <div className="m-more" data-sk-eid="more_gonglue" onClick={() => {
                    this.changeBlock();
                }}>
                    <div className="m-more-btn">{!this.state.show ? '展开更多' : '收起'}</div>
                </div>
            }
        </div>;
    }
}

export default Guide;